<template>
  <v-widget title="Mã vận đơn">
    <template v-slot:widget-header-action>
      <div class="d-flex align-center flex-wrap">
        <v-chip small color="secondary" outlined class="mr-2 font-weight-bold">
          Tổng mã: {{ totalCodes | currency('', 0) }}
        </v-chip>
        <v-chip small color="primary" outlined class="mr-2 font-weight-bold">
          Tổng kiện: {{ totalPack | currency('', 0) }}
        </v-chip>
        <v-chip small color="info" outlined class="mr-2 font-weight-bold">
          Tổng cân: {{ totalWeight | currency('', 2) }} kg
        </v-chip>
        <v-chip small color="success" outlined class="font-weight-bold">
          Tổng khối: {{ totalVolume | currency('', 2) }} m³
        </v-chip>
      </div>
    </template>
    <template v-slot:widget-content>
      <order-transaction
        :locked="orderLocked"
        :disabled="confirmPrice || orderNotDeposit || orderReadonly || !(orderEditRole & 8)"
        :orderId="orderId"
        :orderStatus="order.Status"
        :siteName="order.Site"
        :customerID="customer.ID"
        :customerName="customer.Username"
      ></order-transaction>
    </template>
  </v-widget>
</template>

<script>
import VWidget from "@/components/VWidget";
import OrderTransaction from "@/components/widgets/OrderTransaction";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "TabTransactions",
  components: {
    VWidget,
    OrderTransaction
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    orderLocked: {
      type: Boolean,
      required: true
    },
    confirmPrice: {
      type: Boolean,
      required: true
    },
    totalRealAmountCny: {
      type: [Number, String],
      required: true
    },
    orderNotDeposit: {
      type: Boolean,
      required: true
    },
    orderReadonly: {
      type: Boolean,
      required: true
    },
    orderEditRole: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState({
      transCodes: state =>
        state.orderTransaction &&
        state.orderTransaction.all &&
        Array.isArray(state.orderTransaction.all.data)
          ? state.orderTransaction.all.data
          : []
    }),
    totalCodes() {
      return this.transCodes ? this.transCodes.length : 0;
    },
    totalPack() {
      if (!this.transCodes || this.transCodes.length === 0) return 0;
      return (
        _.sumBy(this.transCodes, item => {
          const num = Number(item.NumberOfPack);
          return !isNaN(num) && num > 0 ? num : 1;
        }) || 0
      );
    },
    totalWeight() {
      if (!this.transCodes || this.transCodes.length === 0) return 0;
      return (
        _.sumBy(this.transCodes, item => {
          const w = parseFloat(item.Weight);
          return !isNaN(w) && w > 0 ? w : 0;
        }) || 0
      );
    },
    totalVolume() {
      if (!this.transCodes || this.transCodes.length === 0) return 0;
      return (
        _.sumBy(this.transCodes, item => {
          const v = parseFloat(item.Volume);
          return !isNaN(v) && v > 0 ? v : 0;
        }) || 0
      );
    }
  }
};
</script>
